export enum REBelegart {
  EINGANGSRECHNUNG = 'EINGANGSRECHNUNG',
  KASSENBELEG = 'KASSENBELEG',
  ANZAHLUNGSBELEG = 'ANZAHLUNGSBELEG',
  PROFORMA_KOSTENBELEG = 'PROFORMA_KOSTENBELEG',
  REISEKOSTENABRECHNUNG = 'REISEKOSTENABRECHNUNG',
}
